import { en } from './en';
import { es } from './es';
import { pt } from './pt';
import { tr } from './tr';
import { ro } from './ro';
import { bg } from './bg';
import { fr } from './fr';
import { sw } from './sw';
import { am } from './am';
import { yo } from './yo';
import { zu } from './zu';

export const translations = { en, es, pt, tr, ro, bg, fr, sw, am, yo, zu };

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'sw', name: 'Kiswahili', flag: '🇰🇪' },
  { code: 'am', name: 'አማርኛ', flag: '🇪🇹' },
  { code: 'yo', name: 'Yorùbá', flag: '🇳🇬' },
  { code: 'zu', name: 'isiZulu', flag: '🇿🇦' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'bg', name: 'Български', flag: '🇧🇬' },
];
